<script setup lang="ts">
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import { createSearchConditionByQuery, type SearchCondition } from './search'
import { ref, watch } from 'vue'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import type { SortOption } from './sort'
import type { Option } from '@/types/app'

const searchCondition = defineModel<SearchCondition>('searchCondition', {
  required: true,
})

const sortOption = defineModel<SortOption>('sortOption', {
  required: true,
})

const searchQuery = ref('')
watch(searchQuery, newValue => {
  searchCondition.value = createSearchConditionByQuery(newValue)
})

const sortOptions: Option<SortOption>[] = [
  { text: '作成日時が新しい順', value: 'createdAtDesc' },
  { text: '作成日時が古い順', value: 'createdAtAsc' },
]
</script>

<template>
  <div :class="$style.controller">
    <DolphinTextInput
      v-model="searchQuery"
      placeholder="検索"
      :class="$style.controller__searchInput"
    />
    <DolphinSelector
      :options="sortOptions"
      v-model="sortOption"
      :class="$style.controller__sortSelector"
    />
  </div>
</template>

<style lang="scss" module>
.controller {
  display: flex;
  gap: 8px;

  &__searchInput {
    flex: 1;
  }

  &__sortSelector {
    flex-shrink: 1;
    min-width: 200px;
  }
}
</style>
